import React, { useState } from 'react'
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import { homeObjOne } from '../components/InfoSection/Data';
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import FinishedGames from '../components/FinishedGames';
import Footer from '../components/Footer';
import StatsSection from '../components/StatsSection';
import { UpcomingGames } from '../components/UpcomingGames';

const TITLE = 'VALGRAEN'

const Home = () => {
    const [isOpen, setIsOpen] = useState(false);
    
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    document.title = TITLE


  return (
    <>
        <Sidebar isOpen={isOpen} toggle={toggle}/>
        <Navbar toggle={toggle}/>
        <HeroSection />
        <InfoSection {...homeObjOne}/>
        <StatsSection />
        <FinishedGames />
        <UpcomingGames />
        <Footer />
    </>
  )
}

export default Home